import React from "react";
import { connect } from "react-redux";
import Toggle from "rsuite/Toggle";
import Modal from "rsuite/Modal";
import Button from "rsuite/Button";
import SelectPicker from "rsuite/SelectPicker";
import InfiniteScroll from "react-infinite-scroll-component";
import { CSVLink } from "react-csv";
import "./coldSmtpResult.css";
import loader from '../../assets/images/loader.gif';
import "rsuite/dist/rsuite.min.css";
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { changeDomainStatus, setOverrideDomain, getColdSMTPDomains, setOwnDomain } from "../../actions/index";

export class ColdSmtpResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      domainFetchError: false,
      domainFetchErrorMessage: '',
      selectedDomain: null,
      selectedValue: null,
      showOverrideModal: false,
      newOverrideDomain: null,
      showOwnDomainModal: false,
      newUseOwnDomain: null,
      searchFilter: '',
      displayedUsers: [],
      hasMore: true,
      // Loading states for each modal
      isToggleLoading: false,
      isOverrideLoading: false,
      isOwnDomainLoading: false,
    };
  }

  componentDidMount() {
    this.props.getColdSMTPDomains()
      .then((response) => {
        if (response === 'success') {
          console.log("ColdSMTP domains fetched successfully");
          this.setState({ domainFetchError: false, domainFetchErrorMessage: "" });
          this.initializeDisplayedUsers();
        } else {
          this.setState({ domainFetchError: true, domainFetchErrorMessage: "An error occurred while fetching domains" });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.coldSmtp.dSearchData !== this.props.coldSmtp.dSearchData) {
      this.initializeDisplayedUsers();
    }
  }

  initializeDisplayedUsers = () => {
    const { dSearchData } = this.props.coldSmtp;
    if (dSearchData && dSearchData.length > 0) {
      const filteredData = this.filterUsers(dSearchData);
      this.setState({
        displayedUsers: filteredData.slice(0, 10),
        hasMore: filteredData.length > 10,
      });
    } else {
      this.setState({
        displayedUsers: [],
        hasMore: false,
      });
    }
  };

  loadMoreUsers = () => {
    const { dSearchData } = this.props.coldSmtp;
    const { displayedUsers } = this.state;

    const filteredData = this.filterUsers(dSearchData);
    const nextBatch = filteredData.slice(displayedUsers.length, displayedUsers.length + 10);
    console.log('Loading more users:', nextBatch.length, 'new items, total now:', displayedUsers.length + nextBatch.length);

    this.setState({
      displayedUsers: [...displayedUsers, ...nextBatch],
      hasMore: displayedUsers.length + nextBatch.length < filteredData.length,
    });
  };

  filterUsers = (data, searchTerm = this.state.searchFilter) => {
    if (!searchTerm || !data) return data || [];
    return data.filter(user => user.email.toLowerCase().includes(searchTerm.toLowerCase()));
  };

  handleSearchChange = (e) => {
    const newSearchFilter = e.target.value;
    const { dSearchData } = this.props.coldSmtp;
    const filteredData = this.filterUsers(dSearchData, newSearchFilter);
    console.log('Search filter changed:', newSearchFilter, 'Filtered items:', filteredData.length);
    this.setState({
      searchFilter: newSearchFilter,
      displayedUsers: filteredData.slice(0, 10),
      hasMore: filteredData.length > 10,
    });
  };

  getCSVData = () => {
    const { dSearchData } = this.props.coldSmtp;
    return dSearchData ? dSearchData.map(user => ({ email: user.email })) : [];
  };

  renderCustomLabel = ({ name, percent }) => `${name}: ${(percent * 100).toFixed(2)}%`;

  renderCampaignData = (dData, domainDistribution) => {
    return (
      <>
        <div className="coldSmtpResult-domainInfo-data">
          {dData.map((item) => (
            <div className="data-field" key={item.id}>
              <div className="data-parameter">{item.domain_name}</div>
              <div className="data-toggle">
                <span className="status-label">Status:</span>
                <Toggle
                  className="status-toggle"
                  checked={item.is_active === 1}
                  onChange={(value) => this.handleToggleClick(item.domain_name, value)}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="coldSmtpResult-domainInfo-data">
          <h3 style={{ textAlign: "left", width: "100%", fontSize: "1.1em", fontWeight: "400", fontFamily: "inherit", textTransform: "uppercase" }}>
            Domain Distribution
          </h3>
          <div className="pie-chart-container">
            <PieChart width={600} height={300}>
              <Pie
                data={domainDistribution}
                dataKey="count"
                nameKey="domain"
                cx="50%"
                cy="50%"
                outerRadius={100}
                fill="#8884d8"
                label={this.renderCustomLabel}
              >
                {domainDistribution.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={this.generateColor(index, domainDistribution.length)} />
                ))}
              </Pie>
              <Tooltip content={this.CustomTooltip} />
            </PieChart>
          </div>
        </div>
      </>
    );
  };

  CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{payload[0].name}</p>
          <p className="tooltip-value">{payload[0].value} Users</p>
        </div>
      );
    }
    return null;
  };

  generateColor = (index, total) => {
    const hue = (index * (360 / total)) % 360;
    return `hsl(${hue}, 70%, 50%)`;
  };

  handleToggleClick = (domainName, newValue) => {
    this.setState({
      showModal: true,
      selectedDomain: domainName,
      selectedValue: newValue,
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      selectedDomain: null,
      selectedValue: null,
      isToggleLoading: false,
    });
  };

  confirmToggleChange = () => {
    this.setState({ isToggleLoading: true });
    const { selectedDomain, selectedValue } = this.state;
    console.log(`Updating domain ${selectedDomain} to ${selectedValue ? "Active" : "Inactive"}`);
    this.props.changeDomainStatus(selectedDomain, selectedValue)
      .then((response) => {
        if (response === 'success') {
          console.log("ColdSMTP domains updated successfully");
          this.setState({ domainFetchError: false, domainFetchErrorMessage: "" });
        } else {
          this.setState({ domainFetchError: true, domainFetchErrorMessage: "An error occurred while updating domain status" });
        }
        this.closeModal();
      })
      .catch((error) => {
        console.error("Error updating domain status:", error);
        this.setState({ 
          domainFetchError: true, 
          domainFetchErrorMessage: "An error occurred: " + error.message,
          isToggleLoading: false
        });
      });
  };

  handleOverrideChange = (value) => {
    if (value !== this.getCurrentOverrideValue()) {
      this.setState({
        showOverrideModal: true,
        newOverrideDomain: value,
      });
    }
  };

  closeOverrideModal = () => {
    this.setState({
      showOverrideModal: false,
      newOverrideDomain: null,
      isOverrideLoading: false,
    });
  };

  confirmOverrideChange = () => {
    this.setState({ isOverrideLoading: true });
    const { newOverrideDomain } = this.state;
    const { uData, dData } = this.props.coldSmtp;
    const email = uData.email;
    const domainName = newOverrideDomain === "N/A" ? null : dData.find(d => d.id === newOverrideDomain).domain_name;

    console.log(`Setting override domain for ${email} to ${domainName || 'N/A'}`);
    this.props.setOverrideDomain(email, domainName)
      .then((response) => {
        if (response === 'success') {
          console.log("Override domain updated successfully");
          this.props.getColdSMTPDomains();
          this.setState({ domainFetchError: false, domainFetchErrorMessage: "" });
        } else {
          this.setState({ domainFetchError: true, domainFetchErrorMessage: "Failed to update override domain" });
        }
        this.closeOverrideModal();
      })
      .catch((error) => {
        console.error("Error updating override domain:", error);
        this.setState({ 
          domainFetchError: true, 
          domainFetchErrorMessage: "An error occurred: " + error.message,
          isOverrideLoading: false
        });
      });
  };

  getCurrentOverrideValue = () => {
    const { uData } = this.props.coldSmtp;
    return uData && uData.override_domain_id ? uData.override_domain_id : "N/A";
  };

  handleOwnDomainChange = (value) => {
    const currentValue = this.getCurrentOwnDomainValue();
    const newValue = value === "Yes";
    if (newValue !== currentValue) {
      this.setState({
        showOwnDomainModal: true,
        newUseOwnDomain: newValue,
      });
    }
  };

  closeOwnDomainModal = () => {
    this.setState({
      showOwnDomainModal: false,
      newUseOwnDomain: null,
      isOwnDomainLoading: false,
    });
  };

  confirmOwnDomainChange = () => {
    this.setState({ isOwnDomainLoading: true });
    const { newUseOwnDomain } = this.state;
    const { uData } = this.props.coldSmtp;
    const email = uData.email;

    console.log(`Setting use own domain for ${email} to ${newUseOwnDomain ? "Yes" : "No"}`);
    this.props.setOwnDomain(email, newUseOwnDomain)
      .then((response) => {
        if (response === 'success') {
          console.log("Use own domain updated successfully");
          this.props.getColdSMTPDomains();
          this.setState({ domainFetchError: false, domainFetchErrorMessage: "" });
        } else {
          this.setState({ domainFetchError: true, domainFetchErrorMessage: "Failed to update use own domain" });
        }
        this.closeOwnDomainModal();
      })
      .catch((error) => {
        console.error("Error updating use own domain:", error);
        this.setState({ 
          domainFetchError: true, 
          domainFetchErrorMessage: "An error occurred: " + error.message,
          isOwnDomainLoading: false
        });
      });
  };

  getCurrentOwnDomainValue = () => {
    const { uData } = this.props.coldSmtp;
    return uData && uData.use_own_domain ? "Yes" : "No";
  };



  conditionalRendering = () => {
    let { dData, domainDistribution, uData, dSearchData } = this.props.coldSmtp;

    const domainNameAssigned = uData && dData
      ? (dData.find(domain => domain.id === uData.assigned_domain_id) || { domain_name: 'N/A' }).domain_name
      : 'N/A';

    const domainOptions = [
      { label: 'N/A', value: 'N/A' },
      ...(Array.isArray(dData) ? dData.map(domain => ({
        label: domain.domain_name,
        value: domain.id,
      })) : [])
    ];

    const ownDomainOptions = [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
    ];

    return (
      <div className="coldSmtpResult-data">
        <div className="coldSmtpResult-domainInfo">
          <div className="coldSmtpResult-domainInfo-title">Domains Information</div>
          <div className="coldSmtpResult-domainInfo-spacer"></div>
          {this.state.domainFetchError ? (
            <div>{this.state.domainFetchErrorMessage}</div>
          ) : (
            dData && domainDistribution ? (
              this.renderCampaignData(dData, domainDistribution)
            ) : (
              <div className="loader-container">
                <img src={loader} alt="loader" width="10%" />
              </div>
            )
          )}
        </div>

        <div className="coldSmtpResult-searchInfo">
          <div className="coldSmtpResult-searchInfo-title">Search Information</div>
          <div className="coldSmtpResult-searchInfo-spacer"></div>
          {uData ? (
            <div className="coldSmtpResult-searchInfo-data">
              <div className="data-field">
                <div className="data-parameter">Email Address</div>
                <div className="data-value">
                  <a
                    style={{ textDecoration: 'none', color: '#2170F4' }}
                    href={`https://www.gmass.co/dashboard/email?email=${uData.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {uData.email}
                  </a>
                </div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Added On</div>
                <div className="data-value">
                  {new Date(uData.created_at).toGMTString()}
                </div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Assigned Domain</div>
                <div className="data-value">
                  {domainNameAssigned}
                </div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Override Domain</div>
                <div className="data-value">
                  <SelectPicker
                    data={domainOptions}
                    value={this.getCurrentOverrideValue()}
                    onChange={this.handleOverrideChange}
                    searchable={false}
                    cleanable={false}
                    style={{ width: 200 }}
                  />
                </div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Use Own Domain</div>
                <div className="data-value">
                  <SelectPicker
                    data={ownDomainOptions}
                    value={this.getCurrentOwnDomainValue()}
                    onChange={this.handleOwnDomainChange}
                    searchable={false}
                    cleanable={false}
                    style={{ width: 100 }}
                  />
                </div>
              </div>
            </div>
          ) : dSearchData && dSearchData.length > 0 ? (
            <div className="dSearchData-container">
              <div className="dSearchData-header">
                <h3 style={{ fontSize: "1.1em", fontWeight: "400", textTransform: "uppercase", margin: 0 }}>
                  Domain Users
                </h3>
                <input
                  type="text"
                  placeholder="Filter emails..."
                  value={this.state.searchFilter}
                  onChange={this.handleSearchChange}
                  style={{ padding: "5px", width: "200px", marginLeft: "10px" }}
                />
              </div>
              <div
                id="scrollableDiv"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #e5e5ea",
                  padding: "10px",
                  borderRadius: "4px",
                }}
              >
                <InfiniteScroll
                  dataLength={this.state.displayedUsers.length}
                  next={this.loadMoreUsers}
                  hasMore={this.state.hasMore}
                  loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv"
                  endMessage={<p style={{ textAlign: 'center' }}>No more users to load</p>}
                >
                  {this.state.displayedUsers.map((user, index) => (
                    <div key={index} style={{ padding: "10px 0", minHeight: "30px" }}>
                      {user.email}
                    </div>
                  ))}
                </InfiniteScroll>
              </div>
              <div style={{ marginTop: "10px" }}>
                <CSVLink
                  data={this.getCSVData()}
                  filename={`domain_users_${new Date().toISOString().split('T')[0]}.csv`}
                  className="rs-btn rs-btn-primary"
                  style={{ textDecoration: "none" }}
                >
                  Download CSV
                </CSVLink>
              </div>
            </div>
          ) : (
            <div>No user or domain search data available</div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="coldSmtpResult">
        {this.conditionalRendering()}
        {/* Toggle Status Modal */}
        <Modal open={this.state.showModal} onClose={this.closeModal} size="sm" backdrop="static" centered="true">
          <Modal.Header>
            <Modal.Title>Confirm Status Change</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {this.state.selectedValue ? "activate" : "deactivate"} this domain?
          </Modal.Body>
          <Modal.Footer>
            <Button 
              onClick={this.confirmToggleChange} 
              appearance="primary" 
              disabled={this.state.isToggleLoading}
            >
              {this.state.isToggleLoading ? (
                <img src={loader} alt="Loading..." style={{ width: '20px', height: '20px' }} />
              ) : (
                "Confirm"
              )}
            </Button>
            <Button onClick={this.closeModal} appearance="subtle" disabled={this.state.isToggleLoading}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Override Domain Modal */}
        <Modal open={this.state.showOverrideModal} onClose={this.closeOverrideModal} size="sm" backdrop="static" centered="true">
          <Modal.Header>
            <Modal.Title>Confirm Override Domain Change</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to set the override domain to{" "}
            {this.state.newOverrideDomain === "N/A"
              ? "N/A"
              : (
                  (Array.isArray(this.props.coldSmtp.dData)
                    ? this.props.coldSmtp.dData.find(d => d.id === this.state.newOverrideDomain)
                    : {}
                  ) || {}
                ).domain_name || "N/A"}
            ?
          </Modal.Body>
          <Modal.Footer>
            <Button 
              onClick={this.confirmOverrideChange} 
              appearance="primary" 
              disabled={this.state.isOverrideLoading}
            >
              {this.state.isOverrideLoading ? (
                <img src={loader} alt="Loading..." style={{ width: '20px', height: '20px' }} />
              ) : (
                "Confirm"
              )}
            </Button>
            <Button onClick={this.closeOverrideModal} appearance="subtle" disabled={this.state.isOverrideLoading}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Use Own Domain Modal */}
        <Modal open={this.state.showOwnDomainModal} onClose={this.closeOwnDomainModal} size="sm" backdrop="static" centered="true">
          <Modal.Header>
            <Modal.Title>Confirm Use Own Domain Change</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to set use own domain to {this.state.newUseOwnDomain ? "Yes" : "No"}?
          </Modal.Body>
          <Modal.Footer>
            <Button 
              onClick={this.confirmOwnDomainChange} 
              appearance="primary" 
              disabled={this.state.isOwnDomainLoading}
            >
              {this.state.isOwnDomainLoading ? (
                <img src={loader} alt="Loading..." style={{ width: '20px', height: '20px' }} />
              ) : (
                "Confirm"
              )}
            </Button>
            <Button onClick={this.closeOwnDomainModal} appearance="subtle" disabled={this.state.isOwnDomainLoading}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { campaign: state.campaign, coldSmtp: state.coldSmtp };
};

export default connect(mapStateToProps, {
  getColdSMTPDomains,
  changeDomainStatus,
  setOverrideDomain,
  setOwnDomain
})(ColdSmtpResult);